import { render, staticRenderFns } from "./ProductInfoModal.vue?vue&type=template&id=37190d83&scoped=true&"
import script from "./ProductInfoModal.vue?vue&type=script&lang=js&"
export * from "./ProductInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37190d83",
  null
  
)

export default component.exports